import React from 'react'
import { css } from '@emotion/react'
import { object, bool } from 'prop-types'
import { Link } from 'gatsby'
import useHydrationContext from '@/hooks/useHydrationContext'
import { DesignToken } from '@livechat/design-system-react-components'

const developedByCss = (theme) => css`
  display: flex;
  align-items: center;
  font-size: 10px;
  line-height: 12px;
  white-space: nowrap;
  font-weight: ${theme.font.bold};
`

const linkCss = css`
  color: var(${DesignToken.ActionPrimaryDefault});

  &:hover {
    color: var(${DesignToken.ActionPrimaryHover});
  }
`

const DevelopedBy = ({ developer, isService }) => {
  const hydrated = useHydrationContext()
  const { company, slug } = developer

  if (!developer) return null

  return (
    <div css={developedByCss} data-test="developed-by">
      {hydrated && isService ? 'Provided' : 'Developed'} by&nbsp;
      <Link to={`/developers/${slug}`} css={linkCss}>
        {company}
      </Link>
    </div>
  )
}

DevelopedBy.propTypes = {
  developer: object,
  isService: bool,
}

export default DevelopedBy
